<template>
    <div class="article-box-wrapper">
        <div class="article-card-shimmer">
            <div class="article-image-wrapper">
                <div class="shimmer image-shimmer"></div>
            </div>
            <div class="article-card-footer">
                <div class="shimmer title-shimmer"></div>
                <div class="shimmer date-shimmer"></div>
                <div class="shimmer button-shimmer"></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    numberOfBoxes?: number
}>(), {
    numberOfBoxes: 10
})
</script>

<style scoped>
.article-box-wrapper {
    width: 100%;
    margin-bottom: 24px;
}

.article-card-shimmer {
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
}

.article-image-wrapper {
    position: relative;
    width: 100%;
    aspect-ratio: 21 / 9;
    overflow: hidden;
}

@media (max-width: 1200px) {
    .article-image-wrapper {
        aspect-ratio: 21 / 9; /* 21:9 banner orientation for mobile */
    }
}

.image-shimmer {
    width: 100%;
    height: 100%;
    border-radius: 0;
}

.article-card-footer {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.title-shimmer {
    width: 85%;
    height: 24px;
    border-radius: 6px;
}

.date-shimmer {
    width: 40%;
    height: 16px;
    border-radius: 4px;
}

.button-shimmer {
    width: 120px;
    height: 18px;
    border-radius: 4px;
    margin-top: 4px;
}

.shimmer {
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f0f0f0;
    background-image: linear-gradient(to right, #f0f0f0 0%, #e0e0e0 20%, #f0f0f0 40%, #f0f0f0 100%);
    background-repeat: no-repeat;
    background-size: 800px 104px;
}

@keyframes placeHolderShimmer {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}

@media (max-width: 1200px) {
    .article-card-shimmer {
        border-radius: 8px;
    }

    .article-card-footer {
        padding: 16px;
        gap: 10px;
    }

    .title-shimmer {
        display: none;
    }

    .date-shimmer {
        display: none;
    }
}

@media (max-width: 640px) {
    .article-box-wrapper {
        margin-bottom: 20px;
    }

    .article-card-footer {
        padding: 12px 16px;
    }
}
</style>

